module.exports = __webpack_public_path__ + "static/media/price-tag-black.c3091be2.svg";